import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { AmazingPanda_Responsive } from "../AmazingPanda/game_responsive";
    export class AmazingPandaLink_Responsive extends AmazingPanda_Responsive {
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "AmazingPandaLink");
        }
    }
